class ClientEditController {

    constructor(
        $uibModal,
        ClientEditService,
        CurrentUser
    ){
        'ngInject';

        this.$uibModal = $uibModal;
        this.ClientEditService = ClientEditService;
        this.CurrentUser = CurrentUser;
    }

    $onInit() {
          this.breadcrumbs = [
            {
                state: 'app.client-admin',
                displayName: 'Client Admin'
            }
        ];

        this.displayClientName = this.client.name;

        this.relatedModels.Day = this.getDays();
        this.countryList = this.ClientEditService.getCountries()
        this.campusList = this.getCampusList()
    }

    /***
     * Open the modal for creating a new campus.
     */
    openCampusModal() {
        this.$uibModal.open({
            component: 'NewCampusModal',
            size: 'md',
            windowClass: 'custom-modal new-campus-modal',
            resolve: {
                clientId: () => this.client.id,
                countryList: () => this.countryList,
                parentController: () => this
            }
        });
    }

    /***
     * Open the modal for creating a new Facility.
     */
    openFacilityModal() {
        this.$uibModal.open({
            component: 'NewFacilityModal',
            size: 'md',
            windowClass: 'custom-modal new-facility-modal',
            resolve: {
                campusList: () => this.campusList,
                parentController: () => this

            }
        });
    }

    getCampusList() {
        let campusList = [];
        for (let country of this.clientTree.countries) {
            for (let campus of country.campuses) {
                campusList.push(campus);
            }
        }
        return campusList;
    }

    getDays() {
        return [
            {
                id: 1,
                name: 'Sun',
            },
            {
                id: 2,
                name: 'Mon'
            },
            {
                id: 3,
                name: 'Tue',
            },
            {
                id: 4,
                name: 'Wed',
            },
            {
                id: 5,
                name: 'Thu'
            },
            {
                id: 6,
                name: 'Fri'
            },
            {
                id: 7,
                name: 'Sat'
            }
        ];
    }

    updateTree() {
        this.ClientEditService.getClientTreeView(this.client.id)
            .then((successResponse) => {
                this.clientTree = successResponse;
                this.displayClientName = this.clientTree.name;
            });

    }

    canAddNewLocationOrFacility() {
        return this.CurrentUser.canAddClientLocationFacility();
    }

}

export default ClientEditController;


// WEBPACK FOOTER //
// ./app/components/client-edit/client-edit-controller.js